import { render, staticRenderFns } from "./PsFiles.vue?vue&type=template&id=0a3929ff&scoped=true&"
import script from "./PsFiles.vue?vue&type=script&lang=js&"
export * from "./PsFiles.vue?vue&type=script&lang=js&"
import style0 from "./PsFiles.vue?vue&type=style&index=0&id=0a3929ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3929ff",
  null
  
)

export default component.exports